import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import store from '../../store/appStore';
import { SECTIONS } from '../../constants/appConstants';
import { serviceTypeMappingColumnList } from '../../constants/MockData';
import _ from 'lodash';

// Component to set Service Type wise Departments and Groups
class ConfigureGroupServiceType extends React.Component {
  // Constructor to set initial state of component
  constructor (props) {
    super(props);
    this.state = {
      groupMasterData: [],
      departmentMasterData: [],
      serviceTypeMasterData: [],
      isInAddMode: false,
      accessServiceMappingData: [],
      configuration: [],
      serviceTypeDepartmentConfig: [],
      selectedEditRowId: undefined,
      updateData: {
        accessGroupServiceTypeId: 0,
        accessGroupId: 0,
        accessGroup: '',
        serviceTypeId: 0,
        serviceType: null,
        departmentId: null,
        departmentName: null
      },
      serviceTypeMappingColumn: _.cloneDeep(serviceTypeMappingColumnList)
    };
  }

  // Get Data before components are mounted
  componentDidMount () {
    this.getRequiredData();
  }

  // Get Master data using API calls before components are mounted
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetAllDepartmentMasterData, // GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Users.GetAccessGroups,
        key: 'groupMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Users.GetServiceTypeDepartmentConfig,
        key: 'serviceTypeDepartmentConfig'
      }
    ])
      .then(({ departmentMasterData, groupMasterData, serviceTypeMasterData, serviceTypeDepartmentConfig }) => {
        this._asyncRequest = null;
        if (serviceTypeDepartmentConfig.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
        }

        serviceTypeDepartmentConfig.config.push({
          attributeName: 'ReadOnlyGroup',
          attributeSortOrder: 8,
          attributeValue: null,
          dataFormat: 'MultiText',
          dbColumn: 'ReadOnlyAccessGroup',
          displayName: null,
          isEditable: true,
          isRequired: false,
          isVisible: true,
          recordId: null,
          sectionDetailId: 0,
          sectionId: 28,
          sectionName: 'Configure Service Type and Department',
          uiColumn: 'Read Only Group'
        });
        this.setState({
          departmentMasterData: departmentMasterData.data || [],
          groupMasterData: groupMasterData.data || [],
          serviceTypeMasterData: serviceTypeMasterData.data || [],
          serviceTypeDepartmentConfig: serviceTypeDepartmentConfig.data || [],
          configuration: serviceTypeDepartmentConfig.config || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get service type and department mapping/configuration details
  GetServiceTypeDepartmentConfig = () => {
    apiRequest({
      url: API_URL.Users.GetServiceTypeDepartmentConfig
    }).then(({ data: response }) => {
      this.setState({
        serviceTypeDepartmentConfig: response || []
      });
    });
  };

  // Handle Cancle event
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
    this.GetServiceTypeDepartmentConfig();
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, serviceTypeMappingColumn } = this.state;
    serviceTypeMappingColumn.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ serviceTypeMappingColumn }, this.forceUpdate());
    return IsValid;
  };

  // Save updated record into database
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; }
    const newParam = this.state.updateData;
    const params = {
      departmentId: newParam.departmentId,
      serviceTypeId: newParam.serviceTypeId,
      accessGroupId: newParam.accessGroupId === '' ? null : newParam.accessGroupId,
      accessGroupServiceTypeId: newParam.accessGroupServiceTypeId,
      readOnlyAccessGroupId: newParam.readOnlyAccessGroupId === '' ? null : newParam.readOnlyAccessGroupId
    };

    apiPost({
      url: API_URL.Users.UpdateServiceTypeDepartmentConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      // debugger;
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined
        });
        this.GetServiceTypeDepartmentConfig();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Open record into Edit mode
  EditRecord = (cellInfo) => {
    this.setState({ selectedEditRowId: { key: 'serviceTypeId', value: cellInfo.serviceTypeId }, isInAddMode: false, updateData: { ...cellInfo }, serviceTypeMappingColumn: _.cloneDeep(serviceTypeMappingColumnList) });
  }

  // Render Edit/Update/Cancel action buttons
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.serviceTypeId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
            )
          : (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_SERVICE_TYPE_DEPARTMENT, SECTIONS.ADD_EDIT)) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
            )}
      </>
    );
  };

  // Handle Edit event of values in the table
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const serviceTypeData = this.state.serviceTypeMasterData;
    const departmentData = this.state.departmentMasterData;
    const accessGroupData = this.state.groupMasterData;
    const param = { ...this.state.updateData };
    const { serviceTypeMappingColumn } = this.state;

    if (fieldName === 'accessGroup') {
      const valueOfAccessGroup = [];
      value.forEach(val => {
        accessGroupData.find((x) => x.accessGroupName === val) &&
          valueOfAccessGroup.push(accessGroupData.find((x) => x.accessGroupName === val).accessGroupId);
      });
      param.accessGroupId = valueOfAccessGroup.join('|');
      param[fieldName] = value.join('|');
      const readAG = row?.readOnlyAccessGroup !== null ? row.readOnlyAccessGroup.split('|') : '';
      const readADId = row?.readOnlyAccessGroupId !== null ? row.readOnlyAccessGroupId.split('|') : '';
      const newReadArr = [];

      if (readADId !== '') {
        readADId.forEach(x => {
          valueOfAccessGroup.forEach(y => {
            if (x == y) {
              const index = readADId.findIndex(xx => xx == x);
              readADId.splice(index, 1);
            }
          });
        });
        readADId.forEach(x => {
          newReadArr.push(accessGroupData.find(yy => yy.accessGroupId == x)?.accessGroupName);
        });

        row.readOnlyAccessGroupId = readADId.join('|');
        row.readOnlyAccessGroup = newReadArr.join('|');
        param.readOnlyAccessGroupId = readADId.join('|');
        param.readOnlyAccessGroup = newReadArr.join('|');
        console.log(readADId);
      }
    } else if (fieldName === 'serviceType') {
      const valueOfServiceType = serviceTypeData.find((x) => x.serviceType === value);
      param.serviceTypeId = (valueOfServiceType || {}).serviceTypeId;
      param[fieldName] = (valueOfServiceType || {}).serviceType;
    } else if (fieldName === 'departmentName') {
      const valueOfDepartment = [];
      value.forEach(val => {
        departmentData.find((x) => x.departmentName === val) &&
          valueOfDepartment.push(departmentData.find((x) => x.departmentName === val).departmentId);
      });
      param.departmentId = valueOfDepartment.join('|');
      param[fieldName] = value.join('|');
    } else if (fieldName === 'readOnlyAccessGroup') {
      const valueOfAccessGroup = [];
      value.forEach(val => {
        accessGroupData.find((x) => x.accessGroupName === val) &&
          valueOfAccessGroup.push(accessGroupData.find((x) => x.accessGroupName === val).accessGroupId);
      });
      param.readOnlyAccessGroupId = valueOfAccessGroup.join('|');
      param[fieldName] = value.join('|');
    } else {
      param[fieldName] = value;
    }

    param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
    param.userEmail = param.userEmail === undefined ? (((store.getState() || {}).auth || {}).account || {}).userName : param.userEmail;

    isGridFormValid(value, serviceTypeMappingColumn.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, reloadTable: !this.state.reloadTable });
  };

  // Add new configuration record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }

    const rowNew = {
      accessGroupServiceTypeId: 0,
      accessGroupId: 0,
      accessGroup: '',
      accessGroupReadOnlyId: 0,
      readOnlyAccessGroup: '',
      serviceTypeId: 0,
      serviceType: null,
      departmentId: null,
      departmentName: undefined
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'serviceTypeId', value: 0 }, updateData: rowNew });
  };

  // Render components based on conditions
  render () {
    const { groupMasterData, departmentMasterData, serviceTypeMappingColumn } = this.state;
    const EditSource = [];
    EditSource.push(
      { key: 'groupMasterData', data: groupMasterData },
      { key: 'departmentMasterData', data: departmentMasterData }
    );
    return (
      <>
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Service Type And Department Configuration
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(serviceTypeMappingColumn, this.state.configuration, [])}
                  data={this.state.serviceTypeDepartmentConfig}
                  config={serviceTypeMappingColumn}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  reload={this.state.reloadTable}
                  isInline={true}
                // AddNewRecord={{ action: this.AddNewRecord, title: 'Add New Mapping', visible: true }}
                // rowBadge={{ key: 'allocationId', equalsTo: 2, class: 'message rotate-badge', title: 'New' }}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigureGroupServiceType;
